import { render, staticRenderFns } from "./plans.vue?vue&type=template&id=8c6bc24a&scoped=true"
import script from "./plans.vue?vue&type=script&setup=true&lang=ts"
export * from "./plans.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./plans.vue?vue&type=style&index=0&id=8c6bc24a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c6bc24a",
  null
  
)

export default component.exports